import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';


function Dashboard(){
   const [stats, setStats] = useState({
    cogeneration: 0,
    power_generation: 0,
    renewable_energy: 0,
    renewable_agencies: 0,
    classifieds: 0,
    suppliers: 0,
    banners : 0
  });

  useEffect(() => {
    axios.get('https://backend-zkgn.onrender.com/api/factorystats')
      .then(res => setStats(res.data))
      .catch(err => console.error("Error fetching stats:", err));
  }, []);

  const factoryStats = [
    { name: 'Cogeneration Plants', count: stats.cogeneration, path: '/cogeneration' },
    { name: 'Power Generation Plants', count: stats.power_generation, path: '/powergeneration' },
    { name: 'Renewable Energy Plants', count: stats.renewable_energy, path: '/renewableenergy' },
    { name: 'Renewable Agencies', count: stats.renewable_agencies, path: '/renewableagency' },
    { name: 'Classifieds', count: stats.classifieds, path: '/classifieds' },
    { name: 'Suppliers', count: stats.suppliers, path: '/suppliers' },
    { name: 'banners', count: stats.banners, path: '/banners' }
  ];
    return ( 
        <div className="container-fluid my-5">
      <div className="row g-4">
        {factoryStats.map((factory, index) => (
          <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
             <Link to={factory.path} className="text-decoration-none">
              <div className="factory-card card text-center shadow-sm h-100">
                <div className="card-body">
                  <h2 className="factory-count">{factory.count}</h2>
                  <h4 className="card-title">{factory.name}</h4>
                </div>
              </div>
              </Link>
          </div>
        ))}
      </div>
    </div>
     );
    
    }

export default Dashboard;